import PropTypes from 'prop-types';
import React from 'react';

const cellStyle = { borderBottom: '1px solid #ddd', padding: '8px 12px', verticalAlign: 'top' };
const headerCellStyle = {
  borderBottom: '2px solid #ddd',
  fontWeight: 'bold',
  padding: '10px 12px',
  textAlign: 'left',
};
const summaryItemStyle = {
  display: 'inline-block',
  margin: '0 16px 4px 0',
  verticalAlign: 'top',
};
const summaryLabelStyle = { color: '#757575', fontSize: '11px', textTransform: 'uppercase' };
const summaryValueStyle = { display: 'block', fontWeight: 500 };

const formatFullName = ({ givenName, middleName, familyName } = {}) => (
  [givenName, middleName, familyName].filter((part) => part && part.trim()).join(' ')
);

const homeAssignment = (rolesAssignments) => rolesAssignments.find((a) => a.isHomeStore);

const ProfileSummary = ({ profile }) => {
  const assignments = Array.isArray(profile.rolesAssignments) ? profile.rolesAssignments : [];
  const fullName = formatFullName(profile.athleteName);
  const home = homeAssignment(assignments);
  const homeLabel = home ? `${home.country}-${home.storeNum}` : '—';

  return (
    <section className="ncss-col-sm-12 ta-sm-l mt4-sm mb4-sm">
      <h4 className="headline-5 mb2-sm">Your Retail Auth profile</h4>

      <div className="mb4-sm">
        {fullName && (
          <div style={summaryItemStyle}>
            <span style={summaryLabelStyle}>Name</span>
            <span style={summaryValueStyle}>{fullName}</span>
          </div>
        )}
        {profile.operatorID && (
          <div style={summaryItemStyle}>
            <span style={summaryLabelStyle}>Employee ID</span>
            <span style={summaryValueStyle}>{profile.operatorID}</span>
          </div>
        )}
        <div style={summaryItemStyle}>
          <span style={summaryLabelStyle}>Home Store</span>
          <span style={summaryValueStyle}>{homeLabel}</span>
        </div>
      </div>

      {assignments.length > 0 && (
        <>
          <h5 className="body-2 mb1-sm">Role assignments ({assignments.length})</h5>
          <table className="ncss-table" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5' }}>
                <th style={headerCellStyle}>Country</th>
                <th style={headerCellStyle}>Store Number</th>
                <th style={headerCellStyle}>Home Store</th>
                <th style={headerCellStyle}>Job Title</th>
                <th style={headerCellStyle}>Roles</th>
              </tr>
            </thead>
            <tbody>
              {assignments.map((assignment) => (
                <tr key={assignment.storeViewId}>
                  <td style={cellStyle}>{assignment.country}</td>
                  <td style={cellStyle}>{assignment.storeNum}</td>
                  <td style={cellStyle}>{assignment.isHomeStore ? 'Yes' : ''}</td>
                  <td style={cellStyle}>{assignment.jobTitle || ''}</td>
                  <td style={cellStyle}>
                    {Array.isArray(assignment.roles) ? assignment.roles.join(', ') : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </section>
  );
};

ProfileSummary.propTypes = {
  profile: PropTypes.shape({
    athleteName: PropTypes.shape({
      familyName: PropTypes.string,
      givenName: PropTypes.string,
      middleName: PropTypes.string,
    }),
    id: PropTypes.string,
    operatorID: PropTypes.string,
    rolesAssignments: PropTypes.arrayOf(PropTypes.shape({
      country: PropTypes.string,
      isHomeStore: PropTypes.bool,
      jobTitle: PropTypes.string,
      roles: PropTypes.arrayOf(PropTypes.string),
      storeNum: PropTypes.string,
      storeViewId: PropTypes.string,
    })),
  }).isRequired,
};

export default ProfileSummary;
